import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import {FormControlLabel} from '@material-ui/core';
import FormHelperText from "@material-ui/core/FormHelperText";

class GIECheckBox extends React.Component<any, any> {
  state = {
    checked: true
  };

  handleChange = event => {
    this.props.emit(event)
  };

  download = (ev) => {
    ev.preventDefault()
    if (this.props.download) {
      this.props.download();
    }
  }

  render() {
    return (
      <div className={this.props.divClassName}>
        <FormControlLabel className={this.props.className}
                          control={
                            <Checkbox id="checkbox"
                                      name={this.props.name}
                                      checked={this.props.checked}
                                      onChange={(event) => this.handleChange(event)}/>
                          }
                          label={
                            <>
                              <span>{this.props.label}</span>
                              {this.props.pdf && <a href="!#" onClick={this.download}>{this.props.pdf}</a>}
                            </>}/>
        {this.props.error && <FormHelperText id={this.props.name + '-helper'}>{this.props.errorText}</FormHelperText>}
      </div>
    );
  }
}

export default (GIECheckBox);
